export enum FirmStatus {	Active = 1,}